<template>
  <Button v-bind="$attrs" :loading="loadingStatus" @click="handleClick"><slot /></Button>
</template>

<script>
import { Button } from 'view-design'
export default {
  name: 'VButton',
  components: {
    Button
  },
  props: {
    autoLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingStatus: false
    }
  },
  methods: {
    handleClick() {
      if (this.autoLoading) {
        this.loadingStatus = true
      }
      this.$emit('click', () => {
        this.loadingStatus = false
      })
    }
  }
}
</script>
